export default "__VITE_PUBLIC_ASSET__9bcebd2e__"